'use client';

import type { ReactNode } from 'react';
import { AuthMarketingSlogan } from '@root/src/auth/layout/AuthMarketingSlogan';

/** Props */
interface CleanLayoutProps {
  children?: ReactNode,
}

/**
 * @description Clean Layout for the login page
 */
const CleanLayout = (props: CleanLayoutProps) => {
  const { children } = props;

  return (
    <div className="grow bg-surface-100">
      <div
        className="absolute inset-y-0 left-[calc(50%_-_300px)] right-0 z-0 hidden flex-col items-end justify-end bg-login-gradient md:flex lg:flex-row"
      >
        <div className="mr-5 w-full max-w-64 rounded-[30px] rounded-br-none bg-white px-5 py-4 lg:-mr-10 lg:mb-[25%] xl:-mr-20 xl:mb-[35%] xl:max-w-84 xl:rounded-[60px] xl:rounded-br-none xl:px-10 xl:py-8">
          <AuthMarketingSlogan />
        </div>
        <div className="w-1/3 bg-no-repeat bg-cover aspect-square bg-login xl:w-1/2" />
      </div>
      {children}
    </div>
  );
};

export default CleanLayout;
